module.exports = {"username":"Gebruikersnaam","password":"Wachtwoord","login":"Inloggen","errors":{"badCredentials":"Email adres en wachtwoord combinatie niet gevonden"},"validation":{"username":{"required":"Gebruikersnaam is verplicht en mag niet leeg zijn"},"password":{"required":"Wachtwoord is verplicht en mag niet leeg zijn"}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/login-form.json
// module id = FDJ4
// module chunks = 1